/**
 * @param {boolean} isOpen - Indica si el modal está abierto o cerrado.
 * @param {Function} onClose - Función que se ejecuta al cerrar el modal.
 * @param {string} title - Título del modal (opcional, por defecto "Modal").
 * @param {string} sizeModal - Tamaño máximo del modal (opcional, por defecto "md").
 * @param {React.ReactNode} children - Contenido dentro del modal.
 */
import { useEffect, useState } from "react"
const Modal = ({ isOpen, onClose, title = "Modal", sizeModal = "md", children }) => {
  const [visible, setVisible] = useState(false) // Controla si el modal está en el DOM
  const [isAnimating, setIsAnimating] = useState(false) // Controla la animación

  useEffect(() => {
    if (isOpen) {
      setVisible(true) // Monta el modal
      setTimeout(() => setIsAnimating(true), 50) // Inicia animación de entrada con un pequeño retraso
    } else {
      setIsAnimating(false) // Inicia animación de salida
      setTimeout(() => setVisible(false), 300) // Desmonta el modal después de la animación
    }
  }, [isOpen])

  if (!visible) return null // No renderizar si no está visible

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50 transition-opacity duration-300 ${
        isAnimating ? "opacity-100" : "opacity-0"
      }`}
      onMouseDown={onClose} // Detecta clic fuera del modal para cerrarlo
    >
      <div
        className={`bg-white rounded-lg shadow-lg p-6 max-w-${sizeModal} w-full relative transform transition-transform duration-300 ${
          isAnimating ? "scale-100" : "scale-90"
        }`}
        onMouseDown={(e) => e.stopPropagation()} // Evita que el modal se cierre si se hace clic dentro de él
      >
        {/* Encabezado del modal */}
        <div className="flex items-center justify-between border-b pb-2">
          <h1 className="text-lg font-bold">{title}</h1>
          <button
            className="text-gray-500 hover:text-gray-700"
            onClick={onClose}
          >
            ✖
          </button>
        </div>

        {/* Contenido dinámico del modal */}
        <div className="mt-4">{children}</div>
      </div>
    </div>
  )
}

export default Modal
